export default "__VITE_ASSET__8871OrR6__"